import React from "react";
import { ArrowRight, Loader2, X } from "lucide-react";

function Modal({
  title,
  description,
  icon: Icon,
  children,
  onClose,
  onSubmit,
  submitting = false,
  submitText = "Save",
}) {
  return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/30 px-4 backdrop-blur-[2px] dark:bg-black/50">
    <div className="w-full max-w-lg overflow-hidden rounded-2xl border border-border-color bg-card-bg shadow-elevated dark:border-dark-border dark:bg-dark-card dark:shadow-dark-elevated">
      <div className="flex items-start justify-between border-b border-border-light px-5 py-4 dark:border-dark-border-light">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-theme-100 text-primary dark:bg-dark-soft-blue dark:text-dark-primary">
            <Icon size={18} />
          </div>

          <div>
            <h3 className="text-sm font-semibold text-text-primary dark:text-dark-text-primary">{title}</h3>

            <p className="mt-0.5 text-[10px] text-text-muted dark:text-dark-text-muted">{description}</p>
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          disabled={submitting}
          className="rounded-lg p-1.5 text-text-muted transition-all hover:bg-app-bg hover:text-text-secondary disabled:cursor-not-allowed disabled:opacity-50 dark:text-dark-text-muted dark:hover:bg-dark-surface dark:hover:text-dark-text-secondary"
        >
          <X size={16} />
        </button>
      </div>

      <form onSubmit={onSubmit}>
        <div className="max-h-[70vh] overflow-y-auto px-5 py-5">
          {children}
        </div>

        <div className="flex items-center justify-between border-t border-border-light bg-app-bg/70 px-5 py-4 dark:border-dark-border-light dark:bg-dark-surface/70">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-lg border border-border-color bg-card-bg px-4 py-2.5 text-xs font-semibold text-text-secondary transition-all hover:bg-app-bg hover:text-text-primary disabled:cursor-not-allowed disabled:opacity-50 dark:border-dark-border dark:bg-dark-card dark:text-dark-text-secondary dark:hover:bg-dark-surface dark:hover:text-dark-text-primary"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={submitting}
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-xs font-semibold text-white shadow-blue transition-all hover:bg-primary-dark hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50 dark:bg-dark-primary dark:shadow-dark-blue dark:hover:bg-dark-primary-hover"
          >
            {submitting ? (
              <>
                <Loader2 size={14} className="animate-spin" />
                Saving...
              </>
            ) : (
              <>
                {submitText}
                <ArrowRight size={14} />
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  </div>
);
}

export default Modal;
